import { useEffect, useRef, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';

const IDLE_EVENTS = ['mousedown', 'mousemove', 'keydown', 'touchstart', 'scroll'];
const WARNING_BEFORE_MS = 60 * 1000;

export default function useIdleTimeout(type, timeoutMs = 30 * 60 * 1000) {
  const navigate = useNavigate();
  const timerRef = useRef(null);
  const warningTimerRef = useRef(null);
  const [showWarning, setShowWarning] = useState(false);

  const logout = useCallback(() => {
    setShowWarning(false);
    sessionStorage.removeItem(`pin-auth-${type}`);
    sessionStorage.removeItem('auth-token');
    if (type === 'admin') {
      api.adminLogout().catch(() => {});
    }
    navigate('/');
  }, [type, navigate]);

  const resetTimer = useCallback(() => {
    setShowWarning(false);
    if (timerRef.current) clearTimeout(timerRef.current);
    if (warningTimerRef.current) clearTimeout(warningTimerRef.current);
    warningTimerRef.current = setTimeout(() => setShowWarning(true), timeoutMs - WARNING_BEFORE_MS);
    timerRef.current = setTimeout(logout, timeoutMs);
  }, [timeoutMs, logout]);

  useEffect(() => {
    resetTimer();
    for (const event of IDLE_EVENTS) {
      window.addEventListener(event, resetTimer, { passive: true });
    }

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      if (warningTimerRef.current) clearTimeout(warningTimerRef.current);
      for (const event of IDLE_EVENTS) {
        window.removeEventListener(event, resetTimer);
      }
    };
  }, [resetTimer]);

  return showWarning;
}
